import { GenericQueryParamsType, GenericResponse, PortType } from '../types';
import { getHeaders, tosApi } from './tosApi';

type PortQueryParamsType = GenericQueryParamsType & {
  company_id?: number | string | undefined;
  function?: string;
  complete_filter?: string;
};

export const portApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    getBasePorts: build.query<
      GenericResponse & { results: Array<PortType> },
      PortQueryParamsType | void
    >({
      query: (params: GenericQueryParamsType) => {
        return {
          url: `/maritime/ports`,
          method: 'GET',
          headers: getHeaders,
          params,
        };
      },
      providesTags: () => [{ type: 'Port', code: '2' }],
    }),
    getBasePort: build.query<{ results: Array<PortType> }, { name?: string }>({
      query: (arg) => {
        const { name } = arg;
        return {
          url: '/maritime/ports',
          method: 'GET',
          headers: getHeaders,
          params: { name },
        };
      },
    }),
    createPort: build.mutation<PortType, PortType>({
      query: (port) => {
        return {
          url: `/maritime/ports`,
          method: 'POST',
          body: port,
        };
      },
      invalidatesTags: () => [{ type: 'Port', code: '2' }],
    }),
    updatePort: build.mutation<PortType, PortType>({
      query: (port) => {
        return {
          url: `/maritime/ports/${port.bi_trigram}`,
          method: 'PUT',
          body: port,
        };
      },
      invalidatesTags: () => [{ type: 'Port', code: '2' }],
    }),
    deletePort: build.mutation<PortType, number>({
      query: (bi_trigram) => {
        return {
          url: `/maritime/ports/${bi_trigram}`,
          method: 'DELETE',
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetBasePortsQuery,
  useLazyGetBasePortsQuery,
  useGetBasePortQuery,
  useCreatePortMutation,
  useUpdatePortMutation,
  useDeletePortMutation,
} = portApi;
